<form [formGroup]="nearbySchoolsForm" ngxsForm="nearbySchoolsState.nearbySchoolsForm">
  <div class="nha-sa-nearby-schools" *ngIf="nearbySchoolsExist">
    <div *ngIf="loading" class="nha-loading">
      <div></div>
    </div>
    <div *ngIf="!loading">
      <div class="nha-sa-nearby-schools-text">
        <h3>{{appContent.resourceStrings["nha.sa.applyforadditionalschool"]}} <span class="nha-pattern-dots"></span></h3>
        <p class="mobile-only">
          <span *ngIf="nearbySchools.length == 1">
            {{appContent.resourceStrings["nha.sa.applyforadditionalschoolmobiletext"]}}
          </span>
          <span *ngIf="nearbySchools.length > 1">
            {{appContent.resourceStrings["nha.sa.applyforadditionalschoolsmobiletext"] | placeholder:nearbySchools.length}}
          </span>
        </p>
        <p class="desktop-only">
          <span *ngIf="nearbySchools.length == 1">
            {{appContent.resourceStrings["nha.sa.applyforadditionalschooldesktoptext"]}}
          </span>
          <span *ngIf="nearbySchools.length > 1">
            {{appContent.resourceStrings["nha.sa.applyforadditionalschoolsdesktoptext"] | placeholder:nearbySchools.length}}
          </span>
        </p>
        <button *ngIf="!showNearbySchools" class="nha-btn nha-btn-primary"
          (click)="showNearbySchools = true">{{appContent.resourceStrings["nha.sa.viewnearbyschools"]}} <span class="fa fa-angle-double-down"></span></button>
      </div>
      <div *ngIf="showNearbySchools" class="nha-sa-nearby-schools-data">
        <p class="mobile-only nearby-schools-subtitle">
          {{appContent.resourceStrings["nha.sa.additionalschoolslotterymobile"]}}
        </p>
        <p class="desktop-only nearby-schools-subtitle">
          {{appContent.resourceStrings["nha.sa.additionalschoolslotterydesktop"]}}
        </p>
        <div formArrayName="nearbySchools" class="nha-sa-nearby-schools-map">
          <app-nearby-schools-map
            *ngIf="nearbySchools.controls && nearbySchools.controls.length > 0"
            [guardianHouseholdLatLng]="guardianHouseholdLatLng"
            [nearbySchools]="nearbySchools.controls"
            (addedToApplication)="addSchoolToApply($event)"
          ></app-nearby-schools-map>
          <app-nearby-schools-list
            [academicYearApplying]="academicYearApplying"
            [nearbySchools]="nearbySchools.controls"
            [formGroup]="nearbySchoolsForm"
          ></app-nearby-schools-list>
        </div>
        <div class="added-schools nha-hide nha-show@md">
          <div *ngIf="addedNearbySchools?.length > 0">
            <h4>{{appContent.resourceStrings["nha.sa.nearbyschoolsadded"]}}</h4>
            <table>
              <thead>
                <th>{{appContent.resourceStrings["nha.sa.school"]}}</th>
                <th>{{appContent.resourceStrings["nha.sa.removeschool"]}}</th>
              </thead>
              <tr *ngFor="let addedNearbySchool of addedNearbySchools">
                <td>{{addedNearbySchool.get('schoolName').value}}</td>
                <td><button (click)="removeSchoolToApply(addedNearbySchool.get('schoolID').value)"><span class="fa fa-trash"></span> {{appContent.resourceStrings["nha.sa.removeschool"]}}</button></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
